// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mobile Screen */

@media screen and (max-width: 767px) {

    .restaurant_detail {
        grid-template-columns: repeat(1, 1fr);
        row-gap: 20px;
        justify-items: center;
    }

    .detail_container {
        height: max-content;
        width: 330px;
        display: grid;
        align-items: center;
        grid-template-columns: repeat(1, 1fr);
        grid-template-rows: 230px 480px 60px;
        padding-top: 20px;
        padding-bottom: 20px;
        justify-items: center;
        background-color: #ffffff;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        row-gap: 10px;
    }

    .detail_restaurant_image {
        width: 290px;
        border-radius: 10px;
    }

    .restaurant_name {
        font-size: 20px;
        justify-self: center;
    }

    .detail_container_rating_location {
        font-size: 14px;
        font-weight: 500;
        display: grid;
        align-items: center;
        grid-template-columns: 20px 35px 20px auto;
    }

    .restaurant_info {
        width: 290px;
        display: grid;
        row-gap: 10px;
    }

    .detail_description {
        text-align: justify;
        font-size: 14px;
        color: rgb(65, 65, 65);
    }

    .likeButtonContainer {
        margin-right: 40px;
    }

    /* Menu */

    .restaurant_menu {
        height: max-content;
        width: 330px;
        display: grid;
        align-items: center;
        grid-template-columns: repeat(1, 1fr);
        grid-template-rows: repeat(auto-fill, 30px);
        padding: 20px 0;
        justify-items: center;
        background-color: #ffffff;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
        border-radius: 10px;
    }

    .food_menu {
        color: #212529;
        font-size: 16px;
        margin-left: 50px;
        justify-self: flex-start;
    }

    .drink_menu {
        color: #212529;
        font-size: 16px;
        margin-left: 50px;
        justify-self: flex-start;
    }
}

@media screen and (min-width: 768px) and (max-width: 1325px) {

    .restaurant_detail {
        display: grid;
        grid-template-columns: repeat(1, 500px);
        row-gap: 35px;
    }

    .detail_restaurant_image {
        width: 400px;
    }

    .detail_container {
        height: max-content;
        display: grid;
        align-items: center;
        grid-template-columns: repeat(1, 1fr);
        grid-template-rows: 310px 510px 60px;
    }

    .restaurant_info {
        width: 400px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/detailResponsive.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;;IAEI;QACI,qCAAqC;QACrC,aAAa;QACb,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,qCAAqC;QACrC,oCAAoC;QACpC,iBAAiB;QACjB,oBAAoB;QACpB,qBAAqB;QACrB,yBAAyB;QACzB,0CAA0C;QAC1C,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,0CAA0C;IAC9C;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,aAAa;IACjB;;IAEA;QACI,mBAAmB;QACnB,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;IACtB;;IAEA,SAAS;;IAET;QACI,mBAAmB;QACnB,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,qCAAqC;QACrC,2CAA2C;QAC3C,eAAe;QACf,qBAAqB;QACrB,yBAAyB;QACzB,0CAA0C;QAC1C,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,wBAAwB;IAC5B;;IAEA;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,wBAAwB;IAC5B;AACJ;;AAEA;;IAEI;QACI,aAAa;QACb,uCAAuC;QACvC,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,aAAa;QACb,mBAAmB;QACnB,qCAAqC;QACrC,oCAAoC;IACxC;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":["/* Mobile Screen */\n\n@media screen and (max-width: 767px) {\n\n    .restaurant_detail {\n        grid-template-columns: repeat(1, 1fr);\n        row-gap: 20px;\n        justify-items: center;\n    }\n\n    .detail_container {\n        height: max-content;\n        width: 330px;\n        display: grid;\n        align-items: center;\n        grid-template-columns: repeat(1, 1fr);\n        grid-template-rows: 230px 480px 60px;\n        padding-top: 20px;\n        padding-bottom: 20px;\n        justify-items: center;\n        background-color: #ffffff;\n        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);\n        border-radius: 10px;\n        row-gap: 10px;\n    }\n\n    .detail_restaurant_image {\n        width: 290px;\n        border-radius: 10px;\n    }\n\n    .restaurant_name {\n        font-size: 20px;\n        justify-self: center;\n    }\n\n    .detail_container_rating_location {\n        font-size: 14px;\n        font-weight: 500;\n        display: grid;\n        align-items: center;\n        grid-template-columns: 20px 35px 20px auto;\n    }\n\n    .restaurant_info {\n        width: 290px;\n        display: grid;\n        row-gap: 10px;\n    }\n\n    .detail_description {\n        text-align: justify;\n        font-size: 14px;\n        color: rgb(65, 65, 65);\n    }\n\n    .likeButtonContainer {\n        margin-right: 40px;\n    }\n\n    /* Menu */\n\n    .restaurant_menu {\n        height: max-content;\n        width: 330px;\n        display: grid;\n        align-items: center;\n        grid-template-columns: repeat(1, 1fr);\n        grid-template-rows: repeat(auto-fill, 30px);\n        padding: 20px 0;\n        justify-items: center;\n        background-color: #ffffff;\n        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);\n        border-radius: 10px;\n    }\n\n    .food_menu {\n        color: #212529;\n        font-size: 16px;\n        margin-left: 50px;\n        justify-self: flex-start;\n    }\n\n    .drink_menu {\n        color: #212529;\n        font-size: 16px;\n        margin-left: 50px;\n        justify-self: flex-start;\n    }\n}\n\n@media screen and (min-width: 768px) and (max-width: 1325px) {\n\n    .restaurant_detail {\n        display: grid;\n        grid-template-columns: repeat(1, 500px);\n        row-gap: 35px;\n    }\n\n    .detail_restaurant_image {\n        width: 400px;\n    }\n\n    .detail_container {\n        height: max-content;\n        display: grid;\n        align-items: center;\n        grid-template-columns: repeat(1, 1fr);\n        grid-template-rows: 310px 510px 60px;\n    }\n\n    .restaurant_info {\n        width: 400px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
